import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import HomeIcon from '@mui/icons-material/Home';
import LockIcon from "@mui/icons-material/Lock";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Box, Button, InputAdornment, Paper, Stack, TextField, Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoaderOverlay from '../../components/custom-loader/LoaderOverlay';
import { useUserContext } from '../../context/UserContext';
import { validateUserData } from '../../custom/UserExport';
import { updateUserPassword } from '../../services/dashboard-service/userService';


const initialErrorState = {
    CurrentPassword: { hasError: false, message: "" },
    NewPassword: { hasError: false, message: "" },
    RepeatNewPassword: { hasError: false, message: "" },
}
function ChangePassword() {

    const navigate = useNavigate()

    const { setUser } = useUserContext()
    const [loading, setLoading] = useState(false);
    let [userData, setUserData] = useState([])
    const [errors, setErrors] = useState(initialErrorState);
    let [formData, setFormData] = useState({
        CurrentPassword: "",
        NewPassword: "",
        RepeatNewPassword: "",
    })
    const [showPassword, setShowPassword] = useState({
        CurrentPassword: false,
        NewPassword: false,
        RepeatNewPassword: false,
    });


    const togglePasswordVisibility = (field) => {
        setShowPassword((prev) => ({
            ...prev,
            [field]: !prev[field]
        }))
    }


    function handleClickForHome(event) {
        event.preventDefault();
        let homeRoute = userData?.routes?.[0]?.route ? userData?.routes?.[0]?.route : "/"
        navigate(homeRoute);
    }

    function handleClickForPassword(event) {
        event.preventDefault();
        navigate('/change-password');
    }


    let fetchUserData = async () => {
        setLoading(true)
        let data = validateUserData()
        setUserData(data);
        setLoading(false)
    }
    useEffect(() => {
        fetchUserData()
    }, [])


    const handleChange = (e) => {
        const { name, value } = e.target
        const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*()\-_\[\]{}]).{6,}$/g;
        const regexMessage =
            "Password must be at least 6 characters long, include at least one uppercase letter, one lowercase letter, one number, and one special character.";

        if (!value.trim()) {
            setErrors((prev) => ({ ...prev, [name]: { hasError: true, message: `${name} is Required` } }))
        }
        else if (!regex.test(value)) {
            setErrors((prev) => ({ ...prev, [name]: { hasError: true, message: regexMessage } }));
        }
        else {
            setErrors((prev) => ({ ...prev, [name]: { hasError: false, message: "" } }))
        }
        setFormData({ ...formData, [name]: value })
    }

    function handleClickForProfile(event) {
        event.preventDefault();
        navigate('/user-profile');
    }

    useEffect(() => {
        if (!userData) {
            navigate('/login');
        }
    }, [userData, navigate]);


    const handleCancel = () => {
        setFormData({
            CurrentPassword: "",
            NewPassword: "",
            RepeatNewPassword: "",
        })
        setShowPassword({
            CurrentPassword: false,
            NewPassword: false,
            RepeatNewPassword: false,
        });
        setErrors(initialErrorState)
    }

    function validatePasswordForm() {
        let hasError = false;

        // Check if any password field is empty
        if (
            !formData.CurrentPassword.trim() ||
            !formData.NewPassword.trim() ||
            !formData.RepeatNewPassword.trim()
        ) {
            setErrors((prev) => ({
                ...prev,
                CurrentPassword: {
                    hasError: !formData.CurrentPassword.trim(),
                    message: "Current Password is required.",
                },
                NewPassword: {
                    hasError: !formData.NewPassword.trim(),
                    message: "New Password is required.",
                },
                RepeatNewPassword: {
                    hasError: !formData.RepeatNewPassword.trim(),
                    message: "Please repeat the new password.",
                },
            }));
            toast("All password fields are required.", {
                autoClose: true,
                type: "error",
            });
            hasError = true;
        }
        const passwordRegex =
            /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*()\-_\[\]{}]).{6,}$/;
        if (formData.CurrentPassword === formData.NewPassword) {
            updateFieldError("NewPassword", "Current and New Password cannot be the same.", "Invalid New Password.")
            hasError = true;
        }
        else if (!passwordRegex.test(formData.CurrentPassword)) {
            updateFieldError("CurrentPassword", "Current Password must include at least 6 characters, one uppercase letter, one lowercase letter, one number, and one special character.", "Invalid Current Password.")
            hasError = true;
        }
        else if (!passwordRegex.test(formData.NewPassword)) {
            updateFieldError("NewPassword",
                "New Password must include at least 6 characters, one uppercase letter, one lowercase letter, one number, and one special character.",
                "Invalid New Password."
            );
            hasError = true;
        }
        else if (formData.NewPassword !== formData.RepeatNewPassword) {
            updateFieldError("RepeatNewPassword", "New Password and Repeat Password Does Not Match.", "Invalid Repeat Password.")
            hasError = true;
        }
        else {
            hasError = false
        }
        return hasError;
    }


    function updateFieldError(fieldName, message, toastMessage) {
        setErrors((prev) => ({
            ...prev,
            [fieldName]: { hasError: true, message },
        }));
        toast(toastMessage, { autoClose: true, type: "error" });
    }

    const updateUserProfileHandler = async (e) => {
        e.preventDefault()
        const hasErrors = validatePasswordForm();
        if (hasErrors) {
            return;
        }
        try {
            setLoading(true)
            let updatedProfileResponse = await updateUserPassword(userData.SecretKey, formData, userData.Token)
            if (updatedProfileResponse && updatedProfileResponse.status === 200) {
                await fetchUserData()
                toast("Password Update Successfully.", {
                    autoClose: true,
                    type: "success"
                })
                handleCancel()
                setLoading(false)
                return;
            }
            else if (updatedProfileResponse?.error?.statusCode === 401 || updatedProfileResponse?.status === 401) {
                toast.error('Session Expired.')
                navigate("/login")
            }
            else {
                toast(updatedProfileResponse?.message, {
                    autoClose: true,
                    type: "error"
                })
                setLoading(false);
                return;

            }
        } catch (error) {
            toast("Try Again Later.", {
                autoClose: true,
                type: "error"
            })
            setLoading(false)
            return;
        } finally {
            setLoading(false)
        }
    }

    const breadcrumbs = [
        <Link
            underline="hover"
            key="1"
            color="inherit"
            href="/"
            onClick={handleClickForHome}
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: '5px 10px',
                borderRadius: '5px',
                textDecoration: 'none',
                color: '#555', // Base text color
                backgroundColor: 'transparent',
                transition: 'all 0.3s ease',
            }}
            onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#f5f5f5'; // Light gray hover effect
                e.currentTarget.style.color = '#333'; // Darker text on hover
            }}
            onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent'; // Revert background
                e.currentTarget.style.color = '#555'; // Revert text color
            }}
        >
            <HomeIcon fontSize="small" />
        </Link>,
        <ArrowForwardIosIcon
            fontSize="small"
            sx={{ color: '#555', margin: '0 0px' }}
            key="separator-1"
        />,
        <Link
            underline="hover"
            key="2"
            color="inherit"
            onClick={handleClickForPassword}
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: '5px 10px',
                borderRadius: '5px',
                textDecoration: 'none',
                color: '#555', // Base text color
                backgroundColor: 'transparent',
                transition: 'all 0.3s ease',
            }}
            onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#f5f5f5'; // Light gray hover effect
                e.currentTarget.style.color = '#333'; // Darker text on hover
            }}
            onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent'; // Revert background
                e.currentTarget.style.color = '#555'; // Revert text color
            }}
        >
            <LockIcon fontSize="small" />
            Change Password
        </Link>,
    ];

    return (
        <div style={{ padding: "1.3rem 2rem", height: "calc(100vh - 250px)" }}>
            <LoaderOverlay loading={loading} />
            <div role="presentation">
                <Stack spacing={1}>
                    <Breadcrumbs
                        separator=""
                        aria-label="breadcrumb"
                        sx={{
                            lineHeight: "0.5",
                            '& ol': {
                                margin: 0, // Remove margin from the ordered list (if any)
                                padding: 0,
                            },
                            '& li': {
                                margin: 0, // Remove margin from list items
                                padding: 0,
                            },
                        }}
                    >
                        {breadcrumbs}
                    </Breadcrumbs>
                </Stack>
            </div>
            <div className='main-user-profile' style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", height: "100%" }}>
                <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                    <Paper elevation={3} style={{
                        padding: "2rem", marginTop: "1.5rem", borderRadius: "8px", backgroundColor: '#fafafa',
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.15)", maxWidth: "500px", width: "100%",
                    }}>
                        <Typography variant="h5" gutterBottom style={{ fontWeight: "bold", color: "#333" }}>
                            Change Password
                        </Typography>
                        <form onSubmit={(e) => updateUserProfileHandler(e)}>
                            <Box
                                component="div"
                                noValidate
                                autoComplete="off"
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                    marginTop: 2,
                                }}
                            >
                                <TextField
                                    name="CurrentPassword"
                                    label="Current Password"
                                    variant="outlined"
                                    type={showPassword.CurrentPassword ? "text" : "password"}
                                    fullWidth
                                    error={errors.CurrentPassword?.hasError}
                                    helperText={errors.CurrentPassword?.message || ''}
                                    onChange={handleChange}
                                    value={formData?.CurrentPassword}
                                    required
                                    sx={{ background: "#ffffff" }}
                                    FormHelperTextProps={{
                                        sx: {
                                            backgroundColor: 'rgb(250, 250, 250)',
                                            width: "100%",
                                        },
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => togglePasswordVisibility('CurrentPassword')}
                                                    edge="end"
                                                >
                                                    {showPassword.CurrentPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TextField
                                    name="NewPassword"
                                    label="New Password"
                                    variant="outlined"
                                    type={showPassword.NewPassword ? "text" : "password"}
                                    error={errors.NewPassword?.hasError}
                                    helperText={errors.NewPassword?.message || ''}
                                    onChange={handleChange}
                                    value={formData?.NewPassword}
                                    required
                                    sx={{ background: "#ffffff" }}
                                    FormHelperTextProps={{
                                        sx: {
                                            backgroundColor: 'rgb(250, 250, 250)',
                                            width: "100%",
                                        },
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => togglePasswordVisibility('NewPassword')}
                                                    edge="end"
                                                >
                                                    {showPassword.NewPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}

                                />

                                <TextField
                                    name="RepeatNewPassword"
                                    label="Repeat New Password"
                                    variant="outlined"
                                    type={showPassword.RepeatNewPassword ? "text" : "password"}
                                    fullWidth
                                    error={errors.RepeatNewPassword?.hasError}
                                    helperText={errors.RepeatNewPassword?.message || ''}
                                    onChange={handleChange}
                                    value={formData?.RepeatNewPassword}
                                    required
                                    sx={{ background: "#ffffff" }}
                                    FormHelperTextProps={{
                                        sx: {
                                            backgroundColor: 'rgb(250, 250, 250)',
                                            width: "100%",
                                        },
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => togglePasswordVisibility('RepeatNewPassword')}
                                                    edge="end"
                                                >
                                                    {showPassword.RepeatNewPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: "1rem", justifyContent: 'flex-end' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type='submit'
                                        style={{ marginTop: "1rem", alignSelf: "flex-end" }}
                                    >
                                        Save Password
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleCancel}
                                        style={{ marginTop: "1rem", alignSelf: "flex-end", backgroundColor: "#f5f5f5", color: "rgba(0, 0, 0, 0.87)" }}
                                    >
                                        Clear
                                    </Button>
                                </Box>
                            </Box>
                        </form>
                    </Paper>
                </div>
            </div>
        </div>
    )
}

export default ChangePassword;